import {
  invalidValueKey,
  invalidValueInterpolation,
} from '@portal/enum/invalidValueTransferError';

export const getMinValueError = (ted: boolean) => {
  return {
    key: ted
      ? invalidValueKey.TED_VALID_MIN_AMOUNT
      : invalidValueKey.P2P_VALID_MIN_AMOUNT,
    interpolation: invalidValueInterpolation.MIN_VALUE,
  };
};

export const getMaxValueError = (ted: boolean) => {
  return {
    key: ted
      ? invalidValueKey.TED_VALID_MAX_AMOUNT
      : invalidValueKey.P2P_VALID_MAX_AMOUNT,
    interpolation: invalidValueInterpolation.MAX_VALUE,
  };
};
